import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 border-t border-zinc-800 mt-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_eco-fuel-store/artifacts/q8ugwsf5_Goodpure%20%282%29.png" 
                alt="GreenPure Biofuel Logo" 
                className="w-12 h-12 object-contain"
              />
              <span className="font-heading text-xl font-bold uppercase">
                GreenPure Biofuel
              </span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              Bengaluru's premier supplier of premium 90mm biomass briquettes.
              Reliable, eco-friendly cooking fuel.
            </p>
            <a
              href="https://wa.me/918431598801"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-lime-400 text-black hover:bg-lime-500 font-bold uppercase tracking-wider px-4 py-2 text-xs transition-colors"
              data-testid="whatsapp-footer-cta"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp Us
            </a>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold uppercase mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-zinc-400 hover:text-lime-400 text-sm transition-colors">
                  Shop Products
                </Link>
              </li>
              <li>
                <Link to="/education" className="text-zinc-400 hover:text-lime-400 text-sm transition-colors">
                  Learn More
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-zinc-400 hover:text-lime-400 text-sm transition-colors">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/vendor-empanelment" className="text-zinc-400 hover:text-lime-400 text-sm transition-colors">
                  Vendor Empanelment
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold uppercase mb-4">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-zinc-400 text-sm">
                <Phone className="w-4 h-4 text-lime-400" />
                +91-8431598801
              </li>
              <li className="flex items-center gap-2 text-zinc-400 text-sm">
                <Mail className="w-4 h-4 text-lime-400" />
                info@greenpure.in
              </li>
              <li className="flex items-center gap-2 text-zinc-400 text-sm">
                <MapPin className="w-4 h-4 text-lime-400" />
                Bengaluru, Karnataka
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold uppercase mb-4">
              Delivery Zones
            </h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-3">
              Same-day delivery across Bengaluru:
            </p>
            <div className="space-y-3 text-xs text-zinc-400">
              <div>
                <p className="text-lime-400 font-semibold mb-1">North Zone</p>
                <p className="leading-relaxed">Yelahanka • Byatarayanapura • Hebbal • Dasarahalli • Jalahalli • Peenya • Sahakara Nagar</p>
              </div>
              <div>
                <p className="text-lime-400 font-semibold mb-1">South Zone</p>
                <p className="leading-relaxed">Jayanagar • BTM Layout • JP Nagar • Bannerghatta • Kumaraswamy Layout • Padmanabhanagar • Basavanagudi</p>
              </div>
              <div>
                <p className="text-lime-400 font-semibold mb-1">East Zone</p>
                <p className="leading-relaxed">Whitefield • Marathahalli • Bellandur • Varthur • CV Raman Nagar • Mahadevapura • KR Puram • ITPL</p>
              </div>
              <div>
                <p className="text-lime-400 font-semibold mb-1">West Zone</p>
                <p className="leading-relaxed">Rajajinagar • Mahalakshmi Layout • Vijayanagar • Malleshwaram • Yeshwanthpur • Kengeri • Nagarbhavi</p>
              </div>
              <div>
                <p className="text-lime-400 font-semibold mb-1">Central Zone</p>
                <p className="leading-relaxed">Koramangala • Indiranagar • HSR Layout • Shantinagar • Ulsoor • Bommanahalli • Electronic City</p>
              </div>
            </div>
            <p className="text-lime-400 text-xs mt-3 font-semibold">Assembly-level dark stores operational</p>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-8 text-center">
          <p className="text-zinc-500 text-sm mb-2">
            www.GreenPureBio.in
          </p>
          <p className="text-zinc-500 text-sm">
            © 2026 GreenPure Biofuel. All rights reserved. Eco-friendly fuel for a sustainable future.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
